import React, { Component } from 'react';

export default class SvgServiceList extends Component {
  static propTypes = {};

  render() {
    let icon;
    switch (this.props.name) {
      case 'duration-arrow':
        icon = (
          <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 34.621"
          >
            <defs></defs>
            <title>Two-Ways-Arrow</title>
            <line
              className="duration-arrow-cls-1"
              x1="5.196"
              y1="17.311"
              x2="506.804"
              y2="17.311"
            />
            <polyline
              className="duration-arrow-cls-1"
              points="497.327 7.834 506.804 17.311 497.327 26.788"
            />
            <polyline
              className="duration-arrow-cls-1"
              points="14.673 26.788 5.196 17.311 14.673 7.834"
            />
          </svg>
        );
        break;
      // case 'one-direction':
      //   icon = (
      //     <svg
      //       xmlns="http://www.w3.org/2000/svg"
      //       // xmlns:xlink="http://www.w3.org/1999/xlink"
      //       version="1.1"
      //       width="1080"
      //       height="1080"
      //       viewBox="0 0 1080 1080"
      //       // xml:space="preserve"
      //     >
      //       <desc>Created with Fabric.js 4.2.0</desc>
      //       <defs></defs>
      //       <g transform="matrix(1 0 0 1 540 540)" id="4682b327-4f09-49be-8c48-98f1319a61a9">
      //         <rect
      //           style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1;"
      //           vector-effect="non-scaling-stroke"
      //           x="-540"
      //           y="-540"
      //           rx="0"
      //           ry="0"
      //           width="1080"
      //           height="1080"
      //         />
      //       </g>
      //       <g transform="matrix(1 0 0 1 540 540)" id="70d2a9d0-9de1-4429-bc42-5968ba933868"></g>
      //       <g transform="matrix(1 0 0 1 540 317.5)" id="6abe3f81-03f1-48e0-bfa9-459152b576fd">
      //         <image
      //           style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
      //           vector-effect="non-scaling-stroke"
      //           xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAABDCAYAAADqK70RAAAAAXNSR0IArs4c6QAABSNJREFUeF7t3LGOG1UUBuBzBwnaSFTUUIIieqRssb7jLdDSQAEFoUsHSBRpeQCUdCnJI6SDxUX8CCshJB6CYumIhX0jRyAlIbu+V1nh8cyX1sc753znSvNnPd4U/hEgQIAAAQKTE0iTm9jABAgQIECAQAgADgEBAgQIEJiggAAwwaUbmQABAgQICADOAAECBAgQmKCAADDBpRuZAAECBAgIAM4AAQIECBCYoIAAMMGlG5kAAQIECAgAzgABAgQIEJiggAAwwaUbmQABAgQICADOAAECBAgQmKCAADDBpRuZAAECBAgIAM4AAQIECBCYoIAAMMGlG5kAAQIECAgAzgABAgQIEJiggAAwwaUbmQABAgQICADOAAECBAgQmKCAADDBpRuZAAECBAgIAM4AAQIECBA4IIHZbH47pXJaStxIKc5XqyffL5fLi9YRBIBWMfUECBAgQGBPAjn3jyLi9MXLl4tSum8Xi58ftrQlALRoqSVAgAABAnsS+Od//j9edvlS0lctIUAA2NMiXZYAAQIECLQI5JyXEenWVe9pCQECQIu+WgIECBAgsCeBnPvziLi56/K1IUAA2CXpdQIECBAgMACBV3/+/+rGakKAADCApWqBAAECBAjsEpjP50ebTXm8q+7f13eFAAGgVlIdAQIECBDYs8CuBwFfbu+qECAA7HmZLk+AAAECBFoErisECAAt6moJECBAgMAABK4jBAgAA1ikFggQIECAQKvA64aAlwNAms1m77Q2oZ4AAQIECBD4/wW6rvuslLhXe+Xnnwl4FgByzu9HdHcjyhe1P0QdAQIECBAgcHgCKcV3Z2dnP6S+798rJX6LiDcPbwwdEyBAgAABAq0CpXQfbQPAg1LiTuub1RMgQIAAAQIHK/B7yrn/IyLePtgRNE6AAAECBAi0CqwFgFYy9QQIECBA4PAFVmk26x+k5COAw9+lCQgQIECAQK1A+jWdnJy8u15vtg8BvlX7NnUECBAgQIDAwQps1uu/P3z2NcDj4+MPuu6NuxHx+cGOo3ECBAgQIEBgl8CqlO7jxeKnX/whoF1UXidAgAABAgMV6LrufinxaWV7f5ayOVosFufben8KuFJNGQECBAgQGJJAzvOHEeXLyp5euPkLAJVqyggQIECAwJAEXvfmLwAMaZt6IUCAAAECFQLXcfMXACqglRAgQIAAgaEI9H2//cz/68p+/vNr/+ff5xmASkVlBAgQIEBgnwLz+fxosymPK3u48ubvNwCVisoIECBAgMC+BXLuH0XEaUUfO2/+AkCFohICBAgQIDAEgZz77df3bu7opermLwAMYaN6IECAAAECFQI552VEunVFafXNXwCoAFdCgAABAgSGIND3/TelxL1Lemm6+QsAQ9ioHggQIECAQKXAJc8BNN/8BYBKcGUECBAgQGAoArPZ/HZK5ZOIciOiW65Wf91fLpcXrf35GmCrmHoCBAgQIDACAQFgBEs0AgECBAgQaBUQAFrF1BMgQIAAgREICAAjWKIRCBAgQIBAq4AA0CqmngABAgQIjEBAABjBEo1AgAABAgRaBQSAVjH1BAgQIEBgBAICwAiWaAQCBAgQINAqIAC0iqknQIAAAQIjEBAARrBEIxAgQIAAgVYBAaBVTD0BAgQIEBiBgAAwgiUagQABAgQItAoIAK1i6gkQIECAwAgEBIARLNEIBAgQIECgVUAAaBVTT4AAAQIERiAgAIxgiUYgQIAAAQKtAgJAq5h6AgQIECAwAoGntwQJQ6wON14AAAAASUVORK5CYII="
      //           x="-256"
      //           y="-33.5"
      //           width="512"
      //           height="67"
      //         ></image>
      //       </g>
      //     </svg>
      //   );
      default:
        icon = <span></span>;
        break;
    }
    return (
      <span className={'inline-block common-svg-service-list  svg-span ' + this.props.className}>
        {icon}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/SvgServiceList.js